// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"33c1dee8","751":"610d63db","806":"85793b9f","936":"fe0271b3"}[chunkId] + ".chunk.js";
};